export interface ActionType{
  title: string;
  tipo: string;
}

export const UPDATE:ActionType = {
  title:"Editar Auxiliar",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Nuevo Auxiliar",
  tipo:"I"
}